import AniLink from "gatsby-plugin-transition-link/AniLink"
import React from "react"

const CategoryLink = ({ cat, text }) => {
  return (
    <AniLink
      fade
      key={cat}
      to={`/categories/${cat.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
      rel="category"
    >
      {text ? text : cat}
    </AniLink>
  )
}

export default CategoryLink
